import React, { Component, Suspense, lazy } from "react"

import { Link, navigate } from "gatsby"

import { Icon } from "@components/icon"

import Basket from "../../search-bar/basket"
import ContactUsBox from "../contact-us-box"

import * as styles from "./navbar-mobile.module.css"

const Search = lazy(() => import("./search/search"))
const NavigationRoutes = lazy(
  () => import("./navigation-routes/navigation-routes")
)

class NavbarMobile extends Component {
  state = {
    showNavigation: false,
    showContacts: false,
    showSearch: false,
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location?.pathname !== this.props.location?.pathname ||
      prevProps.location?.state?.key !== this.props.location?.state?.key
    ) {
      this.close()
    }
  }

  componentWillUnmount() {
    this.removeClass()
  }

  showMenu = (event) => {
    if (event.target.checked) {
      this.addClass()
      this.setState({
        showNavigation: true,
        showSearch: false,
        showContacts: false,
      })
    } else {
      this.removeClass()
      this.setState({ showNavigation: false })
    }
  }

  addClass() {
    document.getElementById("mainBody").className += " stop-scrolling"
  }

  removeClass() {
    document.getElementById("mainBody").className = document
      .getElementById("mainBody")
      .className.replace(/(?:^|\s)stop-scrolling(?!\S)/g, "")
  }

  toggleContacts = () => {
    if (this.state.showContacts) {
      this.close()
    } else {
      this.addClass()
      this.setState({
        showContacts: true,
        showNavigation: false,
        showSearch: false,
      })
    }
  }

  toggleSearch = () => {
    if (this.state.showSearch) {
      this.close()
    } else {
      this.addClass()
      this.setState({
        showSearch: true,
        showNavigation: false,
        showContacts: false,
      })
    }
  }

  handleLinkClick = () => {
    this.removeClass()
    this.setState({ showNavigation: false })
  }

  close = () => {
    this.setState({
      showContacts: false,
      showNavigation: false,
      showSearch: false,
    })
    this.removeClass()
  }

  onSearchClose = (query) => {
    this.close()
    if (query !== "") {
      navigate(`/search?${query}`, { replace: true })
    } else {
      navigate("/search")
    }
  }

  handleKeyActivate = (callback) => (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      callback()
    }
  }

  render() {
    const { showSearch, showNavigation, showContacts } = this.state

    return (
      <div className={styles.container}>
        <input
          type="checkbox"
          checked={showNavigation}
          onChange={this.showMenu}
          className={styles.toggler}
          id="menu"
        />
        <div className={styles.menu}>
          <div className={styles.left}>
            <label
              htmlFor="menu"
              className={styles.iconWrapper}
              aria-label={showNavigation ? "Close menu" : "Menu"}
            >
              <Icon
                id={showNavigation ? "xmark" : "bars"}
                width="22"
                height="22"
              />
            </label>
            <div
              className={styles.iconWrapper}
              onClick={this.toggleSearch}
              onKeyDown={this.handleKeyActivate(this.toggleSearch)}
              role="button"
              tabIndex={0}
              aria-label={showSearch ? "Close search" : "Search"}
            >
              <Icon
                id={showSearch ? "xmark" : "magnifying-glass"}
                width="22"
                height="22"
              />
            </div>
          </div>

          <Link
            onClick={this.handleLinkClick}
            to="/"
            className={styles.logoLink}
          >
            <Icon
              id="logo"
              width="110"
              height="41"
              aria-label="First Fence Home Page"
            />
          </Link>

          <div className={styles.right}>
            <div
              onClick={this.toggleContacts}
              onKeyDown={this.handleKeyActivate(this.toggleContacts)}
              className={styles.iconWrapper}
              role="button"
              tabIndex={0}
              aria-label={showContacts ? "Close contact details" : "Call"}
            >
              <Icon
                id={showContacts ? "xmark" : "phone"}
                width="22"
                height="22"
              />
            </div>
            <div className={styles.iconWrapper}>
              <Basket location={this.props.location} />
            </div>
          </div>
        </div>

        <ContactUsBox show={this.state.showContacts} />
        {this.state.showNavigation ? (
          <Suspense fallback={<div />}>
            <NavigationRoutes navigationList={this.props.navigationList} />
          </Suspense>
        ) : null}
        {this.state.showSearch ? (
          <Suspense fallback={<div />}>
            <Search onClose={this.onSearchClose} />
          </Suspense>
        ) : null}
      </div>
    )
  }
}

export default NavbarMobile
